export default {
    carbonCredit: {
        view: 'Voir',
        edit: 'Modifier',
        back: 'Retour',
        preview: 'Aperçu',
        confirm: 'Confirmer',
        cancel: 'Annuler',
        dashboard: 'Tableau de bord',
        select: 'Sélectionner',
        submit: 'Soumettre',
        save: 'Enregistrer',
        title: 'Crédit Carbone',
        projects: 'Projets',
        carbonProjectCredits: 'Crédits de Projet Carbone',
        carbonCreditProjects: 'Projets de Crédit Carbone',
        exportAs: 'Exporter comme',
        downloadAsCSV: 'Télécharger en CSV',
        downloadAsExcel: 'Télécharger en Excel',
        downloadAsPDF: 'Télécharger en PDF',
        registerNewProject: 'Enregistrer un Nouveau Projet',
        creditInfo: '*Ceci est le nombre approximatif de crédits. Le nombre réel de crédits peut être différent après vérification.',
        search: 'Rechercher',
        projectTitle: 'Titre du Projet',
        projectType: 'Type de Projet',
        country: 'Pays',
        totalCreditsGenerated: 'Total des Crédits Générés',
        status: 'Statut',
        descriptionPlaceholder: "Veuillez fournir une description du projet incluant les objectifs",
        filePreviewNotAvailable: 'L\'aperçu du fichier n\'est pas disponible pour ce type de fichier',
        active: 'Actif',
        inactive: 'Inactif',
        pending: 'En attente',
        proposed: 'Proposé',
        planned: 'Planifié',
        inProgress: 'En Cours',
        operational: 'Opérationnel',
        deactivated: 'Désactivé',
        avoidedDeforestation: 'Déforestation Évitée',
        agroForestry: 'Agroforesterie',
        forestry: 'Foresterie',
        regenerativeAgriculture: 'Agriculture Régénérative',
        agroforestry: 'Agroforesterie',
        regenerative_agriculture: 'Agriculture Régénérative',
        projectDeletedSuccessfully: 'Projet désactivé avec succès',
        projectUpdatedSuccessfully: 'Projet mis à jour avec succès',
        projectRegisteredSuccessfully: 'Projet enregistré avec succès',
        deactivateProjectError: 'Erreur lors de la désactivation du projet',
        deactivate: 'Désactiver',
        deactivateProject: 'Désactiver le Projet',
        deactivateConfirmation: 'Êtes-vous sûr de vouloir désactiver ce projet ?',
        registerProject: 'Enregistrer un Nouveau Projet',
        editProject: 'Modifier le Projet',

        register: { 
            title: 'Enregistrer un Projet',
            editTitle: 'Modifier le Projet',
            projectTitle: 'Titre du Projet',
            projectType: 'Type de Projet',
            description: 'Description',
            selectCountry: "Sélectionner le Pays",
            selectOrganization: 'Sélectionner les Organisations',
            status: 'Statut',
            creditType: 'Type de Crédit',
            creditStart: 'Début de Crédit',
            creditEnd: 'Fin de Crédit',
            standardMethodology: 'Standard/Méthodologie',
            validationDocumentation: 'Documentation de Validation',
            vintage: 'Millésime',
            currency: 'Devise',
            projectInfo: 'Informations du Projet',
            organizationDetails: 'Détails des Organisations',
            attachmentTitle: 'Pièce(s) jointe(s)',
            attachmentInfo: 'Vous pouvez ajouter tout document supplémentaire, images, vidéo et fichiers audio pertinents pour le projet',
            documentation: 'Documentation',
            sdgsTitle: 'Objectifs de Développement Durable (ODD)',
            sdgsInfo: 'Veuillez sélectionner uniquement les objectifs pertinents pour ce projet spécifique. Les organisations auront accès pour voir uniquement les objectifs liés à ce projet.',
            dataCollectionTitle: 'Cycle de Collecte de Données',
            dataCollectionInfo: 'Pour participer au Programme de Crédit Carbone, les agriculteurs doivent fournir des données historiques de ferme lors de l\'inscription et continuer à soumettre des mises à jour de données périodiques tant que le programme reste actif. Cela assure un suivi précis des performances carbone au fil du temps.',
            vintageYear: 'Année de Millésime',
            estimatedCredit: 'Crédits Estimés',
            pricePerCredit: 'Prix Par Crédit',
            moduleName: 'Nom du Module',
            futureData: 'Collecte de Données Récurrentes Futures',
            score: 'Score',
            approval: 'Approbation',

            projectAgreement: 'Accord de Projet',
            headerImage: 'Image d\'En-tête',
            headerImageInfo: '(Taille d\'image d\'en-tête 1920 x 420 pixels. L\'image par défaut sera remplacée par la nouvelle image que vous téléchargez)',
            headerImagePlaceholder: "Image d'En-tête par Défaut",
            responsibleDimitraOffice: 'Bureau Dimitra Responsable',
            selectDimitraOffice: 'Sélectionner le Bureau Dimitra',
            makeASelection: 'Faire une Sélection',
            addNewDimitraOffice: 'Ajouter un Nouveau Bureau Dimitra',
            officeName: 'Nom du Bureau',
            contactPerson: 'Nom de la Personne de Contact',
            phoneNumber: 'Numéro de Téléphone',
            email: 'E-mail',
            address: 'Adresse',
            officeNameRequired: 'Le nom du bureau est requis',
            contactPersonRequired: 'Le nom de la personne de contact est requis',
            addressRequired: 'L\'adresse est requise',
            phoneNumberRequired: 'Le numéro de téléphone est requis',
            phoneNumberInvalid: 'Le numéro de téléphone n\'est pas valide',
            phoneNumberLength: 'Le numéro de téléphone doit comporter au moins 10 chiffres',
            selectVintage: 'Sélectionner le Millésime',
            officeAddedSuccessfully: 'Bureau Dimitra ajouté avec succès',
            errorAddingOffice: 'Erreur lors de l\'ajout du bureau Dimitra',
            searchOrganizations: 'Rechercher des Organisations',
            searchOrganizationsPlaceholder: 'Rechercher par nom d\'organisation...',
            noOrganizationsFound: 'Aucune organisation trouvée',
            loadingOrganizations: 'Chargement des organisations...',
            selectedOrganizations: 'Organisations Sélectionnées',
            errorNegative: 'ne peut pas être négatif.',
            errorRequiredField: '{field} est requis.',
            errorOrganizationRequired: 'Au moins une organisation doit être sélectionnée.',
            errorVintageRequired: 'Au moins une entrée de millésime est requise.',
            errorVintageFieldsRequired: 'Tous les champs de millésime (année, crédits, prix) sont requis.',
            allOrganizations: 'Toutes les Organisations',
            removal: 'Suppression',
            avoided: 'Évité',
            mandatory: 'Obligatoire',
            scoreValidationError: 'Score invalide pour le module "{module}". Le score doit être un nombre entier 0 ou supérieur.',
            approvalValidationError: 'Approbation invalide pour le module "{module}". L\'approbation doit être un nombre entier entre 0 et 100.',
            saveError: 'Échec de l\'enregistrement du projet',
            fileUploadFailed: 'Échec du Téléchargement de Fichier',
            unsupportedFileFormat: 'Format de fichier non pris en charge',
            errorUploadingFile: 'Erreur lors du téléchargement du fichier',
            scoreError: {
                invalid: 'Le score doit être un nombre valide',
                range: 'Le score doit être 0 ou supérieur',
                wholeNumber: 'Le score doit être un nombre entier'
            },
            approvalError: {
                invalid: 'L\'approbation doit être un nombre valide',
                range: 'L\'approbation doit être entre 0 et 100',
                wholeNumber: 'L\'approbation doit être un nombre entier'
            },
            selectStatus: 'Sélectionner le Statut',
            selectCreditType: 'Sélectionner le Type de Crédit',
            dateFormat: 'dd/mm/yyyy',
            standardPlaceholder: 'Standard',
            browse: 'Parcourir',
            currencyPlaceholder: 'USD',
            selectFile: 'Sélectionner un Fichier',
            dragDropFiles: 'Glisser et déposer les fichiers ici',
            hideDetails: 'Masquer les Détails',
            viewDetails: 'Voir les Détails',
            website: 'Site Web',
            month: 'Mois',
            year: 'Année(s)',
        },

        error: 'Erreur',
        success: 'Succès',
        remove: 'Supprimer',

        projectInfo: {
            title: 'Informations du Projet',
            organizationDetail: 'Détail de l\'Organisation',
            subOrganizations: 'Sous-Organisations',
            search: 'Rechercher',
            organizations: 'Organisations',
            users: 'Utilisateurs',
            registrationDate: 'Date d\'Enregistrement',
            close: 'Fermer',
            country: 'Pays',
            organizationsAddress: 'Adresse des Organisations',
            blockchainAddress: 'Adresse Blockchain',
            creditType: 'Type de Crédit',
            projectType: 'Type de Projet',
            officeName: 'Nom du Bureau',
            contactPersonName: 'Nom de la Personne de Contact',
            contactNumber: 'Numéro de Contact',
            email: 'E-mail',
            address: 'Adresse',
            website: 'Site Web',
            companyName: 'Nom de l\'Entreprise',
            companyAddress: 'Adresse de l\'Entreprise',
            web: 'Site Web',
            vintageYear: 'Année de Millésime',
            estimatedCredits: 'Crédits Estimés',
            pricePerCredit: 'Prix Par Crédit',
            module: 'Module',
            recurring: 'Récurrent',
            score: 'Score',
            approval: 'Approbation',
            responsibleDimitraOffice: 'Bureau Dimitra Responsable',
            status: 'Statut',
            standardMethodology: 'Standard/Méthodologie',
            validationDocumentation: 'Documentation de Validation',
            creditStart: 'Début de Crédit',
            creditEnd: 'Fin de Crédit',
            attachmentTitle: 'Pièce(s) jointe(s)',
            sdgsTitle: 'Objectifs de Développement Durable (ODD)',
            dataCollectionTitle: 'Cycle de Collecte de Données',
            dataCollectionInfo: 'Pour participer au Programme de Crédit Carbone, les agriculteurs doivent fournir des données historiques de ferme lors de l\'inscription et continuer à soumettre des mises à jour de données périodiques tant que le programme reste actif. Cela assure un suivi précis des performances carbone au fil du temps.',
            vintage: 'Millésime',
            moduleName: 'Nom du Module',
            futureData: 'Collecte de Données Récurrentes Futures',
            estimatedCredit: 'Crédits Estimés',
        },

        user: {
            title: 'Utilisateur(s) de Crédit Carbone',
            selectOrganization: 'Sélectionner l\'Organisation',
            selectProject: 'Sélectionner le Projet',
            allUsers: 'Tous les Utilisateurs',
            activeUsers: 'Utilisateurs Actifs',
            deactivatedUsers: 'Utilisateurs Désactivés',
            pendingUsers: 'Utilisateurs en Attente',
            search: 'Rechercher',
            farmerName: 'Nom de l\'Agriculteur',
            farmName: 'Nom de la Ferme',
            organizations: 'Organisations',
            country: 'Pays',
            projectTitle: 'Titre du Projet',
            registerProject: 'Enregistrer un Nouveau Projet',
            actions: 'Actions',
            noData: 'Aucun utilisateur trouvé.',
            view: 'Voir',
            viewLandPermit: 'Voir le Titre de Propriété / Permis',
            edit: 'Modifier',
            deactivate: 'Désactiver',
            deactivateUser: 'Désactiver l\'Utilisateur',
            deactivateConfirmation: 'Êtes-vous sûr de vouloir désactiver cet utilisateur ?',
            activate: 'Activer',
            activateUser: 'Activer l\'Utilisateur',
            activateConfirmation: 'Êtes-vous sûr de vouloir activer cet utilisateur ?',
            deactivatedSuccessfully: 'Utilisateur désactivé avec succès',
            activatedSuccessfully: 'Utilisateur activé avec succès',
            deactivationFailed: 'Erreur lors de la désactivation de l\'utilisateur',
            exportAsPdf: 'Exporter en PDF',
            projectDetails: 'Détails du Projet',
            dateJoined: 'Date d\'Adhésion',
            cropGrowingPractice: 'Pratique de Culture',
            farm: 'Ferme',
            rejectAll: 'REJETER TOUT',
            acceptAll: 'ACCEPTER TOUT',
            confirmRejectAll: 'Vous êtes sur le point de rejeter les demandes pour que toutes les fermes rejoignent le projet de crédit carbone. Cette action exclura toutes les fermes soumises par l\'agriculteur dans cette demande. Êtes-vous sûr de vouloir continuer ?',
            confirmAcceptAll: 'Vous êtes sur le point d\'accepter les demandes pour que toutes les fermes rejoignent le projet de crédit carbone. Cette action inclura toutes les fermes soumises par l\'agriculteur dans cette demande. Êtes-vous sûr de vouloir continuer ?',
            dateOfRegistration: 'Date d\'Enregistrement',
            farmRegistrationId: 'ID d\'Enregistrement de Ferme',
            dimitraFarmId: 'ID de Ferme Dimitra',
            notTheFarmer: "Je ne suis pas l'Agriculteur",
            farmerFirstName: 'Prénom de l\'Agriculteur',
            farmerMiddleName: 'Nom de Famille de l\'Agriculteur',
            farmerLastName: 'Nom de Famille de l\'Agriculteur',
            farmerRegistrationId: 'ID d\'Enregistrement de l\'Agriculteur',
            dimitraFarmerId: 'ID d\'Agriculteur Dimitra',
            farmGeofence: 'Géofence de Ferme',
            viewGeofence: 'Voir la Géofence',
            totalFarmSize: 'Taille Totale de Ferme',
            mainGoals: 'Quels sont Vos Objectifs Principaux',
            ownershipType: 'Type de Propriété',
            certifications: 'Certification(s)',
            productionType: 'Type de Production',
            landTitle: 'Titre de Propriété',
            farmLocationAddress: 'Adresse d\'Emplacement de Ferme',
            farmCoordinate: 'Coordonnée de Ferme',
            farmerAgreement: 'Accord de l\'Agriculteur',
            viewSignedAgreement: 'Voir l\'accord signé soumis avec la demande.',
            viewAgreement: 'VOIR L\'ACCORD',
            acceptanceStatus: 'Statut d\'Acceptation',
            currentStatus: 'Statut Actuel',
            reject: 'REJETER',
            accept: 'ACCEPTER',
            farmActivitySubmissions: 'Soumissions d\'Activité de Ferme',
            farmActivitySubmissionsDesc: 'Enregistrements soumis de pratiques agricoles et mises à jour requises pour la vérification de crédit carbone.',
            viewFarmData: 'VOIR LES DONNÉES DE FERME',
            farmData: 'Données de Ferme',
            farmDataDesc: 'Créez vos rapports en intégrant les données de production de diverses sources. Sélectionnez une ou plusieurs sources pour compiler une liste complète des lieux de production pour vos rapports.',
            crops: 'Cultures',
            sowing: 'Semis',
            seedling: 'Semis',
            fertilizer: 'Engrais',
            fertilizerError: 'Soumission incomplète : Les informations d\'engrais pour 4 mois manquent dans l\'entrée de l\'agriculteur.',
            harvesting: 'Récolte',
            livestock: 'Bétail',
            equipment: 'Équipement',
            projectRequests: 'Demandes de Projet',
            userNameAndId: 'Nom d\'Utilisateur et ID',
            email: 'E-mail',
            userRole: 'Rôle d\'Utilisateur',
            status: 'Statut',
            userRegistrationDate: 'Date d\'Enregistrement de l\'Utilisateur',
            pending: 'En attente',
            deactivated: 'Désactivé',
            active: 'Actif',
            selectProjectTypeFirst: 'Sélectionnez le Type de Projet d\'abord',
            noFarmsToReject: 'Aucune exploitation à rejeter',
            allFarmsRejected: 'Toutes les exploitations rejetées avec succès',
            rejectAllError: 'Échec du rejet de toutes les exploitations',
            noFarmsToAccept: 'Aucune exploitation à accepter',
            allFarmsAccepted: 'Toutes les exploitations acceptées avec succès',
            acceptAllError: 'Échec de l\'acceptation de toutes les exploitations',
            farmNotFound: 'Exploitation introuvable ou non associée au projet',
            farmAlreadyRejected: 'L\'exploitation a déjà été rejetée',
            farmRejected: 'Exploitation rejetée avec succès',
            rejectFarmError: 'Échec du rejet de l\'exploitation',
            farmAlreadyAccepted: 'L\'exploitation a déjà été acceptée',
            farmAccepted: 'Exploitation acceptée avec succès',
            acceptFarmError: 'Échec de l\'acceptation de l\'exploitation',
        },
    }
} 